import { routes } from './routes';

/**
 * The single source of truth for "is this top-level URL segment a real
 * application route rather than a fan-group slug".
 *
 * Every value declared in `routes` is reserved: a fan-group slug can never
 * collide with one of these segments because the route always wins. This
 * replaces the bespoke 4-item ignoreList that previously lived in
 * getSlugFromUrl (admin/security/error/portofantwerpemployees) and the
 * duplicated inline `Object.values(routes).includes(slug)` check used by the
 * look query — both of which had drifted out of sync.
 */
export const reservedRouteSegments: ReadonlySet<string> = new Set(
  Object.values(routes)
);

/**
 * Returns true when `segment` is a reserved application route segment (and
 * therefore must NOT be treated as a fan-group slug).
 */
export const isReservedRouteSegment = (
  segment: string | null | undefined
): boolean => !!segment && reservedRouteSegments.has(segment);
